export default __webpack_public_path__ + "static/media/cookies.2736fb72.svg";